import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import {UIArtefakt} from '../../models/uiArtefakt';
import {UiArtefaktService} from '../../services/ui-artefakt.service';
import {Subscription} from 'rxjs';
import {UIArtefaktTyp} from '../../models/uiArtefaktTyp';

@Component({
    selector: 'lv-uiartefakt-renderer',
    templateUrl: './uiartefakt-renderer.component.html',
    styleUrls: ['./uiartefakt-renderer.component.scss'],
    standalone: false
})
export class UIArtefaktRendererComponent implements OnInit, OnDestroy {

  private _uiArtefakt: UIArtefakt;
  private _componentRef: ComponentRef<any>;
  private _artefaktSubscription = Subscription.EMPTY;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver,
              private _uiArtefaktService: UiArtefaktService,
              private _viewContainerRef: ViewContainerRef) {
  }

  get uiArtefakt(): UIArtefakt {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(value: UIArtefakt) {
    this._uiArtefakt = value;
    if (!!this._componentRef) {
      if (this._componentRef.instance.uiArtefakt.WertEingabe !== null &&
          UIArtefaktTyp.ADRESSVORSCHLAG !== this._uiArtefakt.UIArtefakttyp) {
        this._uiArtefakt.WertEingabe = this._componentRef.instance.uiArtefakt.WertEingabe;
      }
      this._componentRef.instance.uiArtefakt = this._uiArtefakt;
    }
  }

  ngOnInit(): void {
    const comp = this._uiArtefaktService.getComponent(this._uiArtefakt);
    if (comp) {
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(comp);
      this._viewContainerRef.clear();
      this._componentRef = this._viewContainerRef.createComponent<any>(componentFactory);
      this._uiArtefakt.recreateComponent = false;
      this._componentRef.instance.uiArtefakt = this._uiArtefakt;
    }
  }

  ngOnDestroy(): void {
    this._artefaktSubscription.unsubscribe();
  }
}
